import { useEffect, useState } from "react";
import SwiperCore, { EffectCoverflow, Pagination } from "swiper";
import { Swiper, SwiperSlide } from "swiper/react";
import iconJornal from '../../../assets/img/Capa Publicações - Jornal Forluz_Prancheta 1.png';
import icoAviao from '../../../assets/img/Capa Publicações - Newsletter_Prancheta 1.png';
import icoRentab from '../../../assets/img/capa_pub_rentabilidade_prancheta_1.png';
import icoSeta from '../../../assets/img/ico-seta.svg';
import icoSorriso from '../../../assets/img/ico-sorrisos.svg';
import api from "../../Services/api";
import "./styles.css";

SwiperCore.use([EffectCoverflow, Pagination]);

const Postagens = (prop: any) => {

    const [isMobile, setIsMobile] = useState(window.innerWidth < 992);

    const [postagens, setPostagens] = useState<any[]>([]);

    useEffect(() => {
        window.addEventListener("resize", () => {
            const ismobile = window.innerWidth < 992;
            if (ismobile !== isMobile) setIsMobile(ismobile);
        }, false);
    }, [isMobile]);

    useEffect(() => {
        api
            .get("/ObterPublicacoesHome")
            .then((response) => {
                setPostagens(response.data.results);
            })
            .catch((err) => {
                throw new Error(err);
            });
    }, []);

    function formatDateAno(dateUtc: any) {        
        if (dateUtc) {
            let month = new Date(dateUtc).toLocaleString('pt-BR', { month: 'long' });
            month = month.charAt(0).toUpperCase() + month.slice(1);
            return month + ' ' + new Date(dateUtc).getFullYear().toString();
        }
    }

    function getTitleUrlPart(url: string) {
        let _url = "";

        if (url.indexOf("/Jornal Forluz/") > 0) {
            _url = "Jornal da Forluz";
        }
        else if (url.indexOf("/Newsletter/") > 0) {
            _url = "Newsletter";
        }
        else if (url.indexOf("/Rentabilidades/") > 0) {
            _url = "Rentabilidades";
        }
        else if (url.indexOf("/Informe Taesaprev/") > 0) {
            _url = "Informe Taesaprev";
        }
        else if (url.indexOf("/Revista Lume/") > 0) {
            _url = "Revista Lume";
        }
        return _url; 
    }
   
    function getIconeType(url: any) {
        let _url = "";

        if (url.indexOf("/Jornal Forluz/") > 0) {
            _url = iconJornal;
        }
        else if (url.indexOf("/Newsletter/") > 0) {
            _url = icoAviao;
        }
        else if (url.indexOf("/Rentabilidades/") > 0) {
            _url = icoRentab;
        }
        else {
            _url = icoSorriso;
        }
        return _url;
    }

    //arrows
    const [swiperIndex, setSwiperIndex] = useState(0);

    const handlePrevClick = () => {
        setSwiperIndex((prevIndex) => prevIndex - 1);
    };

    const handleNextClick = () => {
        setSwiperIndex((prevIndex) => prevIndex + 1);
    };

    const isPrevDisabled = swiperIndex === 0; // Disable prev button when swiperIndex is 0
    const isNextDisabled = swiperIndex === 2; // Disable next button when swiperIndex is at the maximum
    
    return (
        <section key={new Date().getTime()} className="publicacoes py-6 pt-lg-10">
            <div className='container'>
                <div className='row'>
                    <div className='col-lg-3'>
                        <h2 className="text-primary">
                            Publicações
                        </h2>
                    </div>

                    <div className="col-lg-9">
                        <div className="row loaded">
                            {<Swiper

                                grabCursor={true}
                                slidesPerView={"auto"}
                                pagination={false}
                                initialSlide={swiperIndex}
                                breakpoints={{
                                    // when window width is >= 640px
                                    384: {
                                        width: 312,
                                        slidesPerView: "auto",
                                    },
                                    // when window width is >= 768px
                                    590: {
                                        width: 590,
                                        slidesPerView: 2,
                                    },
                                    // when window width is >= 390px
                                    390: {
                                        width: 312,
                                        slidesPerView: "auto",
                                    }
                                }}

                            >
                                {postagens?.map((item, index) => (
                                    <SwiperSlide key={index} >
                                        <div id={"DIV_" + index} className='swiper-slide col-lg-4 col-md-6 load-post border' >
                                            <div className="card-noticia pr-md-3 pl-lg-4" >
                                                <a href={item?.URL}>
                                                    <div className="card-publicacao__topo">
                                                        <p className="mb-0"> <small> {`Nº ${item.ID} - ${formatDateAno(item.Data_x0020_Publicacao)}`}</small> </p>
                                                        <p> {getTitleUrlPart(item?.URL)} </p>
                                                        <p> {item?.Title} &nbsp;</p>
                                                    </div>
                                                    <div className="card-publicacao__img2">
                                                        <img src={getIconeType(item?.URL)} alt="ícone" />
                                                    </div>

                                                    <div className="card-publicacao__text">
                                                        <p className="text-medium">
                                                            {item?.Descricao}
                                                        </p>
                                                    </div>

                                                </a>
                                                <div className="card-publicacao__link  d-none d-lg-block">
                                                    <a href={item?.URL}>
                                                        <svg width="10" height="10" viewBox="0 0 10 10" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                            <path d="M5 1V9" stroke="#F08921" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
                                                            <path d="M1 5H9" stroke="#F08921" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
                                                        </svg>
                                                    </a>
                                                </div>
                                            </div>
                                        </div>
                                    </SwiperSlide>
                                ))}</Swiper>}
                        </div>
                    </div>

                    <div className="col-12 d-lg-none mb-10">
                        <div className="d-flex align-items-center justify-content-end mt-10">
                            <div className={`swiper-button-prev swiper-button publicacoes-prev ${isPrevDisabled ? 'swiper-button-disabled' : ''}`}>
                                <svg onClick={handlePrevClick} className="swiper-arrow swiper-arrow-prev" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                                    <path d="M12.172 7.00017L6.808 1.63617L8.222 0.222168L16 8.00017L8.222 15.7782L6.808 14.3642L12.172 9.00017H0V7.00017H12.172Z"></path>
                                </svg>
                            </div>
                            <div className="arrow-w">
								<div className={`swiper-button-next swiper-button noticias-next ${isNextDisabled ? 'swiper-button-disabled' : ''}`}>
									<svg onClick={handleNextClick} className="swiper-arrow swiper-arrow-next" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
									    <path d="M12.172 7.00017L6.808 1.63617L8.222 0.222168L16 8.00017L8.222 15.7782L6.808 14.3642L12.172 9.00017H0V7.00017H12.172Z"></path>
									</svg>
								</div>
							</div>
                        </div>
                    </div>


                    <div className="col-lg-3 offset-lg-3 ">
                        <a href="../acontece-na-forluz/publicacoes" className="d-flex align-items-center todas-noticias">
                            <span>Ver todas as publicações</span>
                            <img src={icoSeta} alt="Seta" className="transition" />
                        </a>
                    </div>
                </div>
            </div>
        </section>


    );
};
export default Postagens;